<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Characteristic Details</h4>
</div>
<div class="modal-body" *ngIf="characteristicTypes != null">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>Characteristic Type</label>
                    <select class="mvd_form-control" formControlName="characteristicTypeId">
                        <option *ngFor="let characteristic of characteristicTypes" [value]="characteristic.value">{{characteristic.text}}</option>
                    </select>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required" title="* Required">Effective Date</label>
                    <p-calendar [showIcon]="true" formControlName="effectiveDate" [maxDate]="maxDate"></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="form.get('effectiveDate').hasError('required')">Effective date is required</div>
                        <div class="mvd_alert__rule" *ngIf="form.hasError('startAfterEndDate')">Effective date cannot be after End date</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>End Date</label>
                    <p-calendar [showIcon]="true" formControlName="endDate"></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="form.get('endDate').hasError('endDateTooFarInFuture')">End date cannot be 100 years from today</div>
                    </div>
                </div>
                <div class="col-sm-1 mvd_form-group" *ngIf="characteristicId != 0 && showRemove">
                    <label>&nbsp;</label>
                    <a class="icon--delete" title="Delete Characteristic" href="javascript:void(0)" (click)="deleteCustomerCharacteristic()"></a>
                </div>
            </div>
        </fieldset>

        <div class="mvd_alert--info" *ngIf="characteristic.customerCharacteristicTypeId == 22">
            <strong>Reminder:</strong> Add the ACP Mailing Address to the Customer's address record.
        </div>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(form.valid && form.dirty)" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveCharacteristic()"></mvm-spinner-btn>
    </div>
</div>